var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilIkon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.095,
    height: 16.095,
    viewBox: "0 0 16.095 16.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-user-large",
    "data-name": "Icon fa-solid-user-large",
    d: "M7.672,8.632A4.316,4.316,0,1,0,3.357,4.316,4.316,4.316,0,0,0,7.672,8.632Zm-2.838.959A4.834,4.834,0,0,0,0,14.425a.92.92,0,0,0,.92.92h13.5a.92.92,0,0,0,.92-.92,4.834,4.834,0,0,0-4.834-4.834H4.834Z",
    transform: "translate(0.375 0.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilIkon);
export default __webpack_public_path__ + "static/media/profil_ikon.742c442c4f0bffd1e6d3def87b324dee.svg";
export { ForwardRef as ReactComponent };